/* =============================================================================
   bdstore · Landing de cuello (sección de Shopify)
   Los datos de packs y galería los inyecta Liquid en dos <script type="application/json">.
   Sin dependencias.
   ========================================================================== */
(() => {
  'use strict';

  const raiz = document.querySelector('[data-lc-seccion]');
  if (!raiz) return;

  const $ = (sel, ctx = raiz) => ctx.querySelector(sel);
  const $$ = (sel, ctx = raiz) => [...ctx.querySelectorAll(sel)];
  const menosMovimiento = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Los temas de la familia Horizon hacen el scroll dentro de .page-wrapper
     (overflow:auto y altura fija), no en la ventana: window.scrollY se queda
     en 0 y el evento scroll de window no llega. Buscamos el contenedor real. */
  const buscaScroller = (el) => {
    let n = el.parentElement;
    while (n && n !== document.documentElement) {
      const oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 4) return n;
      n = n.parentElement;
    }
    return window;
  };
  const scroller = buscaScroller(raiz);
  const enVentana = scroller === window;
  const posY = () => (enVentana ? window.scrollY : scroller.scrollTop);
  const altoVista = () => (enVentana ? window.innerHeight : scroller.clientHeight);
  const bloqueaScroll = (si) => {
    const el = enVentana ? document.body : scroller;
    el.style.overflow = si ? 'hidden' : '';
  };

  const leerJSON = (sel) => {
    const el = $(sel);
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  };

  /* Formato de precio español («49,99 €»), independiente del ajuste de formato de
     moneda de la tienda, que está puesto a la inglesa («€49,99»). En Liquid hace lo
     mismo el snippet lc-precio. */
  const fmtEur = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });
  const eur = (centimos) => fmtEur.format((centimos || 0) / 100);

  const PACKS = leerJSON('[data-lc-packs]');
  const GALERIA = leerJSON('[data-lc-galeria]');
  /* Sin packs la landing tiene que seguir viva: si aquí salíamos con return, el
     arranque no llegaba a conectaScroll() y todo lo animado (.lc-rev nace con
     opacity:0) se quedaba invisible. Ahora solo se desactiva la compra. */
  const HAY_PACKS = PACKS.length > 0;

  let seleccionado = HAY_PACKS ? (PACKS.find((p) => p.destacado) || PACKS[0]) : null;

  /* --- 1 · Estado de compra ----------------------------------------------- */
  const sincroniza = () => {
    if (!seleccionado) return;
    const p = seleccionado;

    $$('[data-lc-pack]').forEach((el) => {
      const on = el.dataset.lcPack === p.id;
      el.setAttribute('aria-checked', String(on));
      el.tabIndex = on ? 0 : -1;
    });
    $$('[data-lc-mini-pack]').forEach((el) => {
      el.setAttribute('aria-pressed', String(el.dataset.lcMiniPack === p.id));
    });

    $$('[data-lc-precio]').forEach((el) => { el.textContent = eur(p.precio); });

    $$('[data-lc-antes]').forEach((el) => {
      el.hidden = p.ahorro <= 0;
      el.textContent = eur(p.referencia);
    });

    /* La etiqueta «comprado por separado» acompaña siempre al tachado: si no hay
       ahorro no hay tachado, y la etiqueta sola no significaría nada. */
    $$('[data-lc-antes-et]').forEach((el) => { el.hidden = p.ahorro <= 0; });

    $$('[data-lc-ahorro]').forEach((el) => {
      el.hidden = p.ahorro <= 0;
      if (p.ahorro > 0) {
        el.innerHTML =
          '<svg width="12" height="12" aria-hidden="true"><use href="#lc-i-tic"/></svg> ' +
          `Ahorras ${eur(p.ahorro)}${p.ahorroPct ? ` · ${p.ahorroPct} %` : ''}`;
      }
    });

    const detalle = $('[data-lc-detalle]');
    if (detalle) {
      /* El formato sale de los ajustes de la sección: Liquid lo deja en data-formato
         y data-formato-corto. Si faltan, se usan los textos de siempre. */
      const formato = detalle.dataset.formato || '100 g · IVA incluido';
      const formatoCorto = detalle.dataset.formatoCorto || '100 g';
      /* Precio por unidad de medida (RD 3423/2000): se calcula con el gramaje
         de los ajustes, nunca escrito a mano. */
      const gramaje = parseFloat(detalle.dataset.gramaje) || 0;
      const gramosTotal = gramaje * (p.unidades || 1);
      const por100 = gramosTotal > 0
        ? ` · ${eur(Math.round((p.precio * 100) / gramosTotal))}/100 g`
        : '';
      detalle.textContent = p.unidades > 1
        ? `${p.unidades} × ${formatoCorto} · ${eur(p.porUnidad)} por unidad${por100} · IVA incluido`
        : `${formato}${por100}`;
    }

    const fijaPack = $('[data-lc-fija-pack]');
    if (fijaPack) {
      fijaPack.textContent = p.unidades > 1
        ? `${p.nombre} · ${eur(p.porUnidad)}/ud`
        : `${p.nombre} · 100 g`;
    }

    const input = $('[data-lc-variante]');
    if (input) input.value = p.variantId;

    $$('[data-lc-cta]').forEach((b) => {
      b.disabled = !p.disponible;
      if (!p.disponible) b.setAttribute('aria-disabled', 'true');
      else b.removeAttribute('aria-disabled');
    });
  };

  const selecciona = (id, { mover = false } = {}) => {
    const p = PACKS.find((x) => x.id === id);
    if (!p) return;
    seleccionado = p;
    sincroniza();
    if (mover) {
      const card = $(`[data-lc-pack="${id}"]`);
      if (card) card.focus({ preventScroll: true });
    }
  };

  const contenedorPacks = $('.lc-packs');
  if (contenedorPacks) {
    contenedorPacks.addEventListener('click', (e) => {
      const card = e.target.closest('[data-lc-pack]');
      if (card) selecciona(card.dataset.lcPack);
    });
    contenedorPacks.addEventListener('keydown', (e) => {
      const card = e.target.closest('[data-lc-pack]');
      if (!card) return;
      const idx = PACKS.findIndex((p) => p.id === card.dataset.lcPack);
      if ([' ', 'Enter'].includes(e.key)) { e.preventDefault(); selecciona(card.dataset.lcPack); return; }
      let next = null;
      if (['ArrowRight', 'ArrowDown'].includes(e.key)) next = (idx + 1) % PACKS.length;
      if (['ArrowLeft', 'ArrowUp'].includes(e.key)) next = (idx - 1 + PACKS.length) % PACKS.length;
      if (next !== null) { e.preventDefault(); selecciona(PACKS[next].id, { mover: true }); }
    });
  }
  $$('[data-lc-mini-pack]').forEach((b) => {
    b.addEventListener('click', () => selecciona(b.dataset.lcMiniPack));
  });

  /* --- 2 · Añadir al carrito ---------------------------------------------- */
  const form = document.getElementById('lc-form-compra');
  const aviso = $('[data-lc-aviso]');

  const mostrarAviso = (texto, error = false) => {
    if (!aviso) return;
    aviso.hidden = false;
    aviso.textContent = texto;
    aviso.style.color = error ? 'var(--lc-rojo)' : 'var(--lc-tinta-60)';
  };

  if (form) {
    form.addEventListener('submit', async (e) => {
      // Sin JS el formulario hace POST normal a /cart/add y Shopify redirige al carrito.
      e.preventDefault();
      const botones = $$('[data-lc-cta]');
      botones.forEach((b) => { b.disabled = true; });
      mostrarAviso('Añadiendo al carrito…');
      try {
        const datos = new FormData(form);
        const url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') + 'cart/add.js';
        const res = await fetch(url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: datos,
        });
        if (!res.ok) throw new Error('respuesta ' + res.status);
        const carrito = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') + 'cart';
        window.location.href = carrito;
      } catch (err) {
        botones.forEach((b) => { b.disabled = false; });
        mostrarAviso('No hemos podido añadirlo. Inténtalo de nuevo o escríbenos.', true);
      }
    });
  }

  /* --- 3 · Galería -------------------------------------------------------- */
  let galIdx = 0;
  const galImg = $('[data-lc-gal-img]');
  const galVista = $('.lc-galeria__vista');
  const galMinis = $('.lc-galeria__minis');

  const pintaGaleria = () => {
    if (!GALERIA.length || !galImg || !galMinis) return;
    galMinis.innerHTML = GALERIA
      .map((g, i) => `
        <button type="button" class="lc-mini" role="tab" data-lc-gal="${i}"
                aria-selected="${i === 0}" aria-label="Ver imagen ${i + 1}: ${g.etiqueta}">
          <img src="${g.srcSmall}" alt="" width="120" height="160" loading="lazy" decoding="async">
        </button>`)
      .join('');
    muestra(0, true);

    galMinis.addEventListener('click', (e) => {
      const b = e.target.closest('[data-lc-gal]');
      if (b) muestra(+b.dataset.lcGal);
    });
    const prev = $('[data-lc-gal-prev]');
    const next = $('[data-lc-gal-next]');
    if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); muestra(galIdx - 1); });
    if (next) next.addEventListener('click', (e) => { e.stopPropagation(); muestra(galIdx + 1); });

    galVista.addEventListener('click', () => abreLightbox(galIdx));
    galVista.addEventListener('keydown', (e) => {
      if ([' ', 'Enter'].includes(e.key)) { e.preventDefault(); abreLightbox(galIdx); }
      if (e.key === 'ArrowRight') muestra(galIdx + 1);
      if (e.key === 'ArrowLeft') muestra(galIdx - 1);
    });

    let x0 = null;
    galVista.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    galVista.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) muestra(galIdx + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  };

  const muestra = (i, inicial = false) => {
    galIdx = (i + GALERIA.length) % GALERIA.length;
    const g = GALERIA[galIdx];
    const aplica = () => {
      galImg.src = g.src;
      galImg.alt = g.alt;
      const et = $('[data-lc-gal-et]');
      if (et) et.textContent = g.etiqueta;
      galVista.classList.remove('lc-cambiando');
    };
    $$('[data-lc-gal]').forEach((b) => b.setAttribute('aria-selected', String(+b.dataset.lcGal === galIdx)));
    if (inicial || menosMovimiento) { aplica(); return; }
    galVista.classList.add('lc-cambiando');
    setTimeout(aplica, 160);
  };

  /* --- 4 · Lightbox ------------------------------------------------------- */
  let ultimoFoco = null;
  const lb = $('[data-lc-lightbox]');

  const abreLightbox = (i) => {
    if (!lb) return;
    const g = GALERIA[i];
    ultimoFoco = document.activeElement;
    $('[data-lc-lb-img]').src = g.src;
    $('[data-lc-lb-img]').alt = g.alt;
    $('[data-lc-lb-pie]').textContent = `${g.etiqueta} · ${i + 1} de ${GALERIA.length}`;
    lb.hidden = false;
    bloqueaScroll(true);
    requestAnimationFrame(() => {
      lb.classList.add('lc-abierto');
      $('[data-lc-lb-cerrar]').focus();
    });
  };

  const cierraLightbox = () => {
    if (!lb) return;
    lb.classList.remove('lc-abierto');
    bloqueaScroll(false);
    setTimeout(() => { lb.hidden = true; }, 320);
    if (ultimoFoco) ultimoFoco.focus();
  };

  if (lb) {
    $('[data-lc-lb-cerrar]').addEventListener('click', cierraLightbox);
    lb.addEventListener('click', (e) => { if (e.target === lb) cierraLightbox(); });
    document.addEventListener('keydown', (e) => {
      if (lb.hidden) return;
      if (e.key === 'Escape') cierraLightbox();
      if (e.key === 'ArrowRight') { muestra(galIdx + 1); abreLightbox(galIdx); }
      if (e.key === 'ArrowLeft') { muestra(galIdx - 1); abreLightbox(galIdx); }
      // Ciclo de foco real dentro del lightbox, respetando Shift+Tab.
      if (e.key === 'Tab') {
        const focos = [...lb.querySelectorAll(
          'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )].filter((el) => !el.hidden && el.offsetParent !== null);
        if (!focos.length) return;
        const primero = focos[0];
        const ultimo = focos[focos.length - 1];
        const actual = document.activeElement;
        if (e.shiftKey && (actual === primero || !lb.contains(actual))) {
          e.preventDefault();
          ultimo.focus();
        } else if (!e.shiftKey && (actual === ultimo || !lb.contains(actual))) {
          e.preventDefault();
          primero.focus();
        }
      }
    });
  }

  /* --- 5 · FAQ ------------------------------------------------------------ */
  $$('.lc-faq__btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      const abierto = btn.getAttribute('aria-expanded') === 'true';
      $$('.lc-faq__btn').forEach((o) => {
        if (o === btn) return;
        o.setAttribute('aria-expanded', 'false');
        const p = document.getElementById(o.getAttribute('aria-controls'));
        if (p) p.style.height = '0px';
      });
      btn.setAttribute('aria-expanded', String(!abierto));
      panel.style.height = abierto ? '0px' : `${panel.scrollHeight}px`;
    });
  });

  /* --- 6 · Vídeos --------------------------------------------------------- */
  const conectaVideos = () => {
    const bucles = $$('.lc-historia__media video, .lc-ritual__media video');
    bucles.forEach((v) => {
      v.muted = true;
      v.loop = true;
      v.controls = false;
      v.setAttribute('playsinline', '');
      v.preload = 'none';
      v.pause();
    });

    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver((es) => {
        es.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) {
            v.preload = 'auto';
            if (!menosMovimiento) v.play().catch(() => {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.25 });
      bucles.forEach((v) => obs.observe(v));
    } else {
      bucles.forEach((v) => { v.preload = 'auto'; v.play().catch(() => {}); });
    }

    /* Vídeo de demostración: arranca solo al entrar en pantalla y silenciado.
       Los navegadores solo permiten la reproducción automática sin sonido, así
       que `muted` no es opcional: sin él la llamada a play() se rechaza. El
       control del audio se le devuelve al usuario con un botón propio. */
    const caja = $('[data-lc-demo]');
    const video = caja ? caja.querySelector('video') : null;
    if (caja && video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = false;
      video.controls = false;
      video.setAttribute('playsinline', '');
      video.preload = 'metadata';

      const btn = $('[data-lc-demo-sonido]');

      if (menosMovimiento) {
        /* Sin autoreproducción: se dejan los controles nativos para que la
           persona lo ponga en marcha (y regule el volumen) cuando quiera. */
        video.controls = true;
      } else {
        if (btn) btn.hidden = false;

        const arranca = () => { video.preload = 'auto'; video.play().catch(() => {}); };

        if ('IntersectionObserver' in window) {
          const obsDemo = new IntersectionObserver((es) => {
            es.forEach((e) => {
              if (e.isIntersecting) arranca();
              else if (!video.paused) video.pause();
            });
          }, { threshold: 0.4 });
          obsDemo.observe(video);
        } else {
          arranca();
        }
      }

      if (btn) {
        const icono = btn.querySelector('use');
        const txt = btn.querySelector('[data-lc-demo-sonido-txt]');
        const pinta = () => {
          const conSonido = !video.muted;
          btn.setAttribute('aria-pressed', String(conSonido));
          btn.setAttribute(
            'aria-label',
            conSonido ? 'Silenciar el vídeo de demostración' : 'Activar el sonido del vídeo de demostración'
          );
          if (txt) txt.textContent = conSonido ? 'Silenciar' : 'Activar sonido';
          if (icono) icono.setAttribute('href', conSonido ? '#lc-i-sonido' : '#lc-i-mudo');
        };
        btn.addEventListener('click', () => {
          video.muted = !video.muted;
          pinta();
          // Al quitar el silencio sigue donde estaba: no se reinicia.
          if (!video.muted && video.paused) video.play().catch(() => {});
        });
        pinta();
      }
    }
  };

  /* --- 6.b · Reseñas de Judge.me ------------------------------------------
     El widget lo pinta la app (a veces por JS, después de cargar la página, y
     otra vez al paginar), así que no basta con marcar las tarjetas al arrancar:
     hay que vigilar el contenedor y marcar las que vayan apareciendo. La
     animación es la misma que la del resto de la landing: subir y aparecer al
     asomar por la ventana, escalonada de tres en tres. */
  const conectaResenas = () => {
    const caja = $('[data-lc-jdgm]');
    if (!caja) return;

    const obs = !menosMovimiento && 'IntersectionObserver' in window
      ? new IntersectionObserver((es) => {
        es.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('lc-is-in'); obs.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 })
      : null;

    // Judge.me tiene dos generaciones de widget en circulación: la nueva («revamp»,
    // clases jm-*) y la clásica (jdgm-*). Se marcan las dos.
    const SEL = ['.jm-review-item', '.jm-align-review-item', '.jdgm-rev']
      .map((s) => `${s}:not([data-lc-anim])`)
      .join(',');

    const marca = () => {
      const nuevas = [...caja.querySelectorAll(SEL)];
      nuevas.forEach((el, i) => {
        el.setAttribute('data-lc-anim', '');
        el.style.setProperty('--lc-i', String(i % 3));
        if (obs) obs.observe(el); else el.classList.add('lc-is-in');
      });
    };

    marca();

    if ('MutationObserver' in window) {
      let pendiente = false;
      // Solo childList: si vigilásemos también los atributos, el propio
      // data-lc-anim que ponemos aquí volvería a disparar el observador.
      // El respiro es con setTimeout y no con requestAnimationFrame porque este
      // último se congela mientras la pestaña está en segundo plano, que es justo
      // cuando la app suele terminar de pintar el widget.
      new MutationObserver(() => {
        if (pendiente) return;
        pendiente = true;
        setTimeout(() => { pendiente = false; marca(); }, 0);
      }).observe(caja, { childList: true, subtree: true });
    }
  };

  /* --- 7 · Revelado y CTA fija ------------------------------------------- */
  const conectaScroll = () => {
    const items = $$('.lc-rev');
    if (menosMovimiento || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('lc-is-in'));
    } else {
      const obs = new IntersectionObserver((es) => {
        es.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('lc-is-in'); obs.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      items.forEach((el) => obs.observe(el));
    }

    const fija = $('[data-lc-cta-fija]');
    const escena = $('.lc-escena');
    if (!fija && !escena) return;
    document.body.classList.add('lc-tiene-cta-fija');
    let tick = false;
    const alScroll = () => {
      const y = posY();
      if (fija) fija.classList.toggle('lc-visible', y > altoVista() * 0.4);
      if (escena && !menosMovimiento && window.innerWidth > 900) {
        escena.style.setProperty('--lc-par', `${Math.max(-40, -y * 0.045)}px`);
      }
      tick = false;
    };
    scroller.addEventListener('scroll', () => {
      if (!tick) { tick = true; requestAnimationFrame(alScroll); }
    }, { passive: true });
    alScroll();
  };

  /* --- Arranque ---------------------------------------------------------- */
  pintaGaleria();
  conectaVideos();
  conectaResenas();
  conectaScroll();
  sincroniza();

  // El editor de temas recarga las secciones por AJAX
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.contains(raiz)) location.reload();
  });
})();
